// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"14099ff4","13":"aebe5ddb","31":"15757506","85":"71762450","143":"52d95313","185":"21fcb3b4","244":"896bfe73","247":"3b1eba79","442":"ec1d2285","504":"dc46f84b","528":"ec1f595b","742":"1d38d9cd","747":"cd30d1b5","787":"e7852734","970":"4b719216","994":"0d545066"}[chunkId] + ".chunk.js";
};